import api from '@/services/apiService';

export type NotificationCategory = 'all' | 'event' | 'booking' | 'community';

export interface PlayerNotification {
  id: number;
  category: Exclude<NotificationCategory, 'all'>;
  type: string;
  title: string;
  body: string;
  actionLabel: string | null;
  actionPath: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationListData {
  items: PlayerNotification[];
  nextCursor?: string;
}

export interface NotificationUnreadData {
  hasUnread: boolean;
}

interface ApiEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export async function fetchNotifications(
  category: NotificationCategory,
  cursor?: string
): Promise<NotificationListData> {
  const { data } = await api.get<ApiEnvelope<NotificationListData>>('/client/notifications', {
    params: { category, cursor: cursor || undefined },
  });
  return data.data ?? { items: [] };
}

export async function fetchNotificationUnread(): Promise<boolean> {
  const { data } = await api.get<ApiEnvelope<NotificationUnreadData>>('/client/notifications/unread');
  return Boolean(data.data?.hasUnread);
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.post(`/client/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/client/notifications/read-all');
}
